import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// Global styles in correct order
import '@shared/styles/variables.css';
import '@shared/styles/base.css';
import '@app/styles/index.css';
import '@app/styles/App.css';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
